module.exports = __webpack_public_path__ + "img/16581255_L.eb80f5ce.png";